import {
  ProductItemModel,
  transformItemBoxDto,
  transformPartialUserDtoToProductItemUser,
} from '@marketplace-web/item-box/product-item-data'

import { CatalogItemDto } from '../types/dtos/catalog-item'
import { transformCurrencyAmountDtoOrString } from './currency-amount'
import { findThumbnail } from '../utils/photo'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
}

const getItemThumbnail = (
  photos: Array<{
    is_main: boolean
    thumbnails: Array<{ type: ItemThumbnailSize | string; url: string }>
  }>,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ is_main }) => is_main)

  return findThumbnail(photo, size)
}

const getDominantColor = (photos: Array<{ is_main: boolean; dominant_color_opaque: string }>) => {
  if (!photos.length) return null

  const photo = photos.find(({ is_main }) => is_main === true)

  if (!photo) return null

  return photo.dominant_color_opaque
}

export const transformCatalogItemDtoToProductItem = (item: CatalogItemDto): ProductItemModel => ({
  id: item.id,
  title: item.title,
  url: item.url,
  favouriteCount: item.favourite_count,
  priceWithDiscount: item.discount
    ? transformCurrencyAmountDtoOrString(item.discount, item.discount.currency_code)
    : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.price.currency_code),
  badge: item.badge,
  serviceFee: item.service_fee
    ? transformCurrencyAmountDtoOrString(item.service_fee, item.service_fee.currency_code)
    : null,
  totalItemPrice: item.total_item_price
    ? transformCurrencyAmountDtoOrString(item.total_item_price, item.total_item_price.currency_code)
    : undefined,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  user: transformPartialUserDtoToProductItemUser(item.user),
  photos:
    (item.photo && [
      {
        url: item.photo.url,
        thumbnails: item.photo.thumbnails,
        isMain: item.photo.is_main,
        imageNo: item.photo.image_no,
      },
    ]) ||
    [],
  viewCount: item.view_count,
  itemBox: item.item_box && transformItemBoxDto(item.item_box),
})

export const transformCatalogItemDtosToProductItems = (
  items: Array<CatalogItemDto>,
): Array<ProductItemModel> => items.map(transformCatalogItemDtoToProductItem)
